/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Hero_GainInputs */

const en_us2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in estimated max strength`)
};

const pt_br2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na força máxima estimada`)
};

const es_419_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en fuerza máxima estimada`)
};

const pt_pt2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na força máxima estimada`)
};

const fr_fr2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en force max estimée`)
};

const de_de2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bei der geschätzten Maximalkraft`)
};

const it_it2_progress_hero_gain = /** @type {(inputs: Progress_Hero_GainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di forza massima stimata`)
};

/**
* | output |
* | --- |
* | "in estimated max strength" |
*
* @param {Progress_Hero_GainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_hero_gain = /** @type {((inputs?: Progress_Hero_GainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Hero_GainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_hero_gain(inputs)
	if (locale === "es-419") return es_419_progress_hero_gain(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_hero_gain(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_hero_gain(inputs)
	if (locale === "de-DE") return de_de2_progress_hero_gain(inputs)
	if (locale === "it-IT") return it_it2_progress_hero_gain(inputs)
	return en_us2_progress_hero_gain(inputs)
});
export { progress_hero_gain as "progress.hero_gain" }